import {getApiUrl} from '../../../api'
import {getFingerprintId} from './fingerprint'
import {setAccessToken, setAuthUserId} from './tokenStorage'
import {setAuthMode, useTokens, withCredentialsForAuthEndpoints} from './authTransport'
import axios from 'axios'

let refreshTimer: number | undefined

function onAuthRoute() {
    try { return window.location.pathname.startsWith('/auth') } catch { return false }
}

function scheduleAccessAutoRefresh(expiresAt?: number, skewSec = 45) {
    if (refreshTimer) clearTimeout(refreshTimer)
    if (!expiresAt) return
    // eslint-disable-next-line react-hooks/rules-of-hooks
    if (!useTokens() || onAuthRoute()) return
    const delayMs = Math.max(0, (expiresAt - skewSec) * 1000 - Date.now())
    refreshTimer = window.setTimeout(() => {
        if (!useTokens() || onAuthRoute()) return
        exchangeRefreshToAccess().catch(() => {})
    }, delayMs)
}

type SignInOk =
    | { status: 'ok' }
    | { status: '2fa-required'; method: 'email' | 'totp'; userId: number }

export async function signIn(email: string, password: string): Promise<SignInOk> {
    const finger_print = (window as any).__APP_FP__ ?? await getFingerprintId()
    const baseUrl = await getApiUrl()

    const { data: signInResp } = await axios.post(
        `${baseUrl}?q=users__sign-in`,
        { object:'users', command:'sign-in', data:{ email, password, finger_print } },
        { headers:{ 'Content-Type':'application/json' }, withCredentials: withCredentialsForAuthEndpoints() }
    )

    const payload = signInResp?.data
    if (payload?.oauth_type === 'none') {

        const { data: accessResp } = await axios.post(
            `${baseUrl}?q=2fa__tokens`,
            { object:'2fa', command:'tokens', data:{ type:'access_token', finger_print } },
            { headers:{ 'Content-Type':'application/json' }, withCredentials: withCredentialsForAuthEndpoints() }
        )

        const { token, expires_at } = accessResp.data
        setAccessToken(token, expires_at)
        setAuthMode('token')
        scheduleAccessAutoRefresh(expires_at)
        return { status: 'ok' }
    }

    if (payload?.oauth_type === 'email' || payload?.oauth_type === 'totp') {
        if (payload.user_id) setAuthUserId(payload.user_id)
        setAuthMode('token')
        return { status:'2fa-required', method: payload.oauth_type, userId: payload.user_id }
    }

    throw new Error('Неожиданный ответ sign-in')
}

export async function submit2faCode(code: string): Promise<void> {
    const finger_print = (window as any).__APP_FP__ ?? await getFingerprintId()
    const baseUrl = await getApiUrl()

    const { data: refreshResp } = await axios.post(
        `${baseUrl}?q=2fa__tokens`,
        { object:'2fa', command:'tokens', data:{ type:'refresh_token', code, finger_print } },
        { headers:{ 'Content-Type':'application/json' }, withCredentials: withCredentialsForAuthEndpoints() }
    )

    if (refreshResp.status === 302) throw new Error('Необходимо заново ввести логин и пароль')
    if (refreshResp.status !== 200 || refreshResp.data !== true) throw new Error('Неверный или просроченный код')

    await exchangeRefreshToAccess({ force: true })
}

export async function exchangeRefreshToAccess(opts?: { force?: boolean }): Promise<string> {
    if (!opts?.force) {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        if (!useTokens() || onAuthRoute()) throw new Error('refresh disabled (mode is not token)')
    }
    const finger_print = (window as any).__APP_FP__ ?? await getFingerprintId()
    const baseUrl = await getApiUrl()

    const { data: accessResp } = await axios.post(
        `${baseUrl}?q=2fa__tokens`,
        { object:'2fa', command:'tokens', data:{ type:'access_token', finger_print } },
        { headers:{ 'Content-Type':'application/json' }, withCredentials: withCredentialsForAuthEndpoints() }
    )

    if (accessResp.status === 302) throw new Error('Необходимо заново ввести логин и пароль')

    const { token, expires_at } = accessResp.data
    setAccessToken(token, expires_at)
    setAuthMode('token')
    scheduleAccessAutoRefresh(expires_at)
    return token
}

export function rescheduleAutoRefresh(exp?: number) {
    scheduleAccessAutoRefresh(exp)
}
